import { BrailleIcon } from './BrailleIcon';

/**
 * author: Michael Richins
 * id 3B62C43D-F1BC-45AB-AB68-B1B854009FD8
 * name braille
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/braille.svg
 * tags
 */
export const TouchReadingIcon = BrailleIcon;
export default TouchReadingIcon